import { BaseErrorLayout } from '@dvb/ui';
import { DesktopContainer } from '@milestone-portal/ui/DesktopContainer/DesktopContainer';
import { Footer } from '@milestone-portal/ui/Footer/Footer';
import { HeaderBar } from '@milestone-portal/ui/HeaderBar/HeaderBar';

export function RootError() {
  return (
    <div className="flex w-full flex-col">
      <DesktopContainer>
        <HeaderBar />
        <BaseErrorLayout className="bg-background w-full" />
      </DesktopContainer>
      <Footer />
    </div>
  );
}
